// eslint-disable-next-line import/prefer-default-export
export const VIEW_OPENINGS_BY = {
  OFFICE: 'OFFICE',
  PROVIDER: 'PROVIDER',
};
